<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

   <div class="container-fluid mt--6">
      <div class="row">
     	 <div class="col">
     	 
     <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">Requests</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="requests">
            <el-table-column label="Request ID"
                             prop="id"
                              min-width="140px"
                             >
            </el-table-column>
            
              <el-table-column label="Request"
             				 min-width="220px"
             				 >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.type===1">Appointment Of New Director</span>
           				  <span v-if="scope.row.type===2">Resignation Of New Director</span>
           				  <span v-if="scope.row.type===3">Allotment OF New Shares</span>
           				  <span v-if="scope.row.type===4">Share Transfer</span>
           				  <span v-if="scope.row.type===5">Change Of Company Address</span>
           				  <span v-if="scope.row.type===6">Change Of Company Name</span>
           				  <span v-if="scope.row.type===7">Opening Of New Bank Account</span>
           				  <span v-if="scope.row.type===8">Schedule AGM</span>
           				  <span v-if="scope.row.type===901">Custom Request</span>
           				  <span v-if="scope.row.type===5015">Company Incorporation</span>
           				  <span v-if="scope.row.type===5016">Appointment Of Company Secretary</span>
          			</template>
        	</el-table-column>
        	
        	
             <el-table-column label="Created"
                             prop="created_at_str"
                             min-width="140px"
                             >
            </el-table-column>
            
           
        	
        	 <el-table-column label="Status" 
        	 					 min-width="150px"
        	 				>
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">In Progress</span>
           				 <span v-if="scope.row.status===4">Completed</span>
           				 <span v-if="scope.row.status===5">Cancelled</span>
          			</template>
        	</el-table-column>
        	
        	 <el-table-column label="" >
                	<template slot-scope="scope">
                	  <base-button
                    @click.native="viewRequest(scope.row)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>

          
        </el-table>
    </div>
    <!-- end invoices due -->
    <div style="min-height:120px;"></div>
    
    
    

    
		</div><!-- end col-->
       
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
   import { Table, TableColumn} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  	 [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    data() {
      return {
     	 requests:[],
	
      };
    },
    methods: {
      viewRequest(row) {
		this.$router.push( '/view-request/'+	row.id);
      }
    },
    mounted() {
      	swal.showLoading();
        const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_requests/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.requests = response.data.requests;
   			 swal.close();
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














